import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenu } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IProfil } from '../../../../../core/resources/profil.resource';
import { IMenuItemClass } from '../../../../../core/services/menu/menu-item.service';

interface IPageAs0042 extends IComponentController {
    menuBandeau: IMenu;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    formulaireGrp: IFormulaire;
    formulaireTmp: IFormulaire;
    sutMultiOccurrenceOptions: IMultiOccurrenceOptions;
    sutMultiOccurrence: IMultiOccurrence;
    rgvMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rgvMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function As0042Controller(
    MenuItemAction: IMenuItemActionClass,
    $stateParams: IStateParamsService,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    as0042Route: IRoute,
    $state: IStateService,
    profil: IProfil,
    MenuItem: IMenuItemClass
) {
    const vm: IPageAs0042 = this;

    vm.valeursEcran = ecranDetails.valeurs;
    vm.monoOccurrenceOptions = {
        fonctions: {
            afficherMenusDansEntete: true,
            boutonEnregistrerHaut: false,
            suiviModification: false,
            boutonDupliquer: false,
            supprime: false,
            exportation: false
        },
        menus: [
            new MenuItemAction(
                'LBL_BTN_SIMULER',
                'BOUSIM',
                () => ({
                    demcleint: vm.monoOccurrence.data.demcleint,
                    aftcleint: vm.monoOccurrence.data.aftcleint,
                    temcleint: vm.monoOccurrence.data.temcleint,
                    asgcleint: vm.monoOccurrence.data.asgcleint,
                    ahtcleint: vm.monoOccurrence.data.ahtcleint,
                    strcleint: vm.monoOccurrence.data.strcleint,
                    sttdatdeb: vm.monoOccurrence.data.sttdatdeb,
                    sttdatfin: vm.monoOccurrence.data.sttdatfin,
                    actcleint: vm.monoOccurrence.data.actcleint,
                    vaesttprv: vm.monoOccurrence.data.vaesttprv,
                    sttqte: vm.monoOccurrence.data.sttqte
                }),
                {
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_SIMULER',
                        lblConfirm: 'LBL_BTN_LAN_SIM',
                        largeurFormulaire: 50,
                        formulaire: new Formulaire([
                            new FormulaireItem('actcleintnew', {
                                required: true,
                                default: $stateParams.actcleint,
                                resourceParams: (data: any) => {
                                    return {
                                        sttdatdeb: data.sttdatdeb
                                    };
                                }
                            }),
                            new FormulaireItem('sttdatdebnew', {
                                required: true,
                                default: $stateParams.sttdatdeb
                            }),
                            new FormulaireItem('sttdatfinnew', {
                                default: $stateParams.sttdatfin
                            }),
                            new FormulaireItem('vaesttprvnew', { 
                                default: $stateParams.vaesttprv 
                            }),
                            new FormulaireItem('sttqtenew', { 
                                default: $stateParams.sttqte 
                            })
                        ], { largeurDefaut: 33.33 })
                    },
                    fonction: 'BOUSIM',
                    iconButton: false,
                    icon: '',
                    class: 'md-raised ex-button-action',
                    successAction: (retour: any) => {
                        $state.go(as0042Route.NAME, {
                            menuId: $stateParams.menuId,
                            id: profil.preferences.ciecleint,
                            demcleint: retour.demcleint,
                            aftcleint: retour.aftcleint,
                            temcleint: retour.temcleint,
                            asgcleint: retour.asgcleint,
                            ahtcleint: retour.ahtcleint,
                            strcleint: retour.strcleint,
                            sttdatdeb: retour.sttdatdeb,
                            sttdatfin: retour.sttdatfin,
                            actcleint: retour.actcleint,
                            vaesttprv: retour.vaesttprv,
                            sttqte: retour.sttqte
                        });
                    }
                }
            )
        ]
    };

    vm.formulaireGrp = new Formulaire(
        'LBL_BLC_GROUPE',
        [
            new FormulaireItem('demcleint', { default: $stateParams.demcleint }),
            new FormulaireItem('urgcleint', { default: $stateParams.urgcleint }),
            new FormulaireItem('strcleint', { default: $stateParams.strcleint }),
            new FormulaireItem('aftcleint', {
                default: $stateParams.aftcleint,
                nombreLibellesDetailsCacher: 4,
                resourceParams: (data: any) => {
                    return {
                        sttdatdeb: data.sttdatdeb
                    };
                }
            }),
            new FormulaireItem('temcleint', { default: $stateParams.temcleint }),
            new FormulaireItem('asgcleint', { default: $stateParams.asgcleint }),
            new FormulaireItem('ahtcleint', {
                default: $stateParams.ahtcleint,
                resourceParams: (data: any) => {
                    return {
                        asgcleint: data.asgcleint
                    };
                },
                nombreLibellesDetailsCacher: 1
            })
        ],
        { largeurDefaut: 33.33 }
    );

    vm.formulaireTmp = new Formulaire('LBL_BLC_TMP', [
        new FormulaireItem('actcleint', {
            largeur: 50,
            default: $stateParams.actcleint,
            resourceParams: (data: any) => {
                return {
                    sttdatdeb: data.sttdatdeb
                };
            }
        }),
        new FormulaireItem('sttdatdeb', { largeur: 25, default: $stateParams.sttdatdeb }),
        new FormulaireItem('sttdatfin', { largeur: 25, default: $stateParams.sttdatfin }),
        new FormulaireItem('vaesttprv', { largeur: 50, default: $stateParams.vaesttprv }),
        new FormulaireItem('sttqte', { largeur: 25, default: $stateParams.sttqte })
    ]);

    vm.sutMultiOccurrenceOptions = {
        brisNiveaux: 'niveau',
        bloc: 'sut',
        colonnesVisibles: [
            { nom: 'lab', 
                largeur: 250,
                menu: [
                    new MenuItem(() => { }, {
                        icon: 'not_interested',
                        hidden: (rowData: any) => !rowData.flgacces,
                        iconButton: true,
                        noAction: true
                    })
                ]}
        ],
        colonnesCachees: ['niveau', 'etat', 'flgacces']
    };

    vm.rgvMultiOccurrenceOptions = {
        brisNiveaux: 'niveau',
        bloc: 'rgv',
        colonnesVisibles: [
            { nom: 'lab', largeur: 250,
                menu: [
                    new MenuItem(() => { }, {
                        icon: 'not_interested',
                        hidden: (rowData: any) => !rowData.flgacces,
                        iconButton: true,
                        noAction: true
                    })
                ]}
        ],
        colonnesCachees: ['niveau', 'etat', 'flgacces']
    };
}
